
require("./../node_modules/@module-federation/nextjs-mf/src/include-defaults.js");
import authCookie from 'utils/authCookie';
import dynamic from 'next/dynamic';
import Spinner from 'global/Loading/SecondarySpinner';

const ArticleLayout = dynamic(
  () => import('features/static/UserArticleLayout'),
);
const About = dynamic(() => import('features/about'), {
  loading: () => <Spinner />,
});
const AboutContent = dynamic(() => import('constants/contents/about'));

interface AboutPageProps {
  isLoggedIn: boolean;
}

const AboutPage = ({ isLoggedIn }: AboutPageProps) => {
  if (isLoggedIn) {
    return <ArticleLayout source={<AboutContent />} title="About Stockbit" />;
  }

  return <About />;
};

export async function getServerSideProps(context) {
  const isLoggedIn = Boolean(authCookie.getIsLoggedIn(context));

  return {
    props: {
      isLoggedIn,
    },
  };
}

export default AboutPage;
